module.exports = __webpack_public_path__ + "img/waistline_pocket_position.0536a2e3.png";